import PageHeader from "../components/PageHeader";
import Conditions from "../components/Conditions";
import { conditions } from "../data/content";

export default function ConditionsPage() {
  return (
    <>
      <PageHeader
        eyebrow={conditions.eyebrow}
        title={conditions.heading}
        lead={conditions.intro}
      />
      <Conditions headless />
    </>
  );
}
